import React from "react";
import { Link } from "react-router-dom";

// Custom Styles
import "../scss/pages/notFound.styles.scss";

// Assets
import NotFoundIcon from "../assets/img/not-found.svg";

function NotFound() {
  return (
    <section className="not-found">
      <img src={NotFoundIcon} alt="" />
      <h2>La página que buscas no fue encontrada.</h2>
      <Link to="/">Regresar a Inicio</Link>
    </section>
  );
}

export default NotFound;
